import { Edit, Delete, QrCode2 } from "@mui/icons-material";
import React from "react";
import { Tooltip, IconButton, Switch } from "@mui/material";
import { setInsumoId, setDefaultData } from "store/modules/Insumos";
import { v4 as uuidv4 } from 'uuid';
import { modifyInsumo } from "./functions";

const handleChange = async (e, data, refresh, setRefresh) => {
  data.internal = e.target.checked;
  await modifyInsumo(data);
  setRefresh(!refresh);
}

export const columns = (setOpen, setMode, setOpenDelete, dispatch, refresh, setRefresh, handleOpenQR) => {
  return [{
    field: `${uuidv4()}`,
    headerName: "Acciones",
    width: 180,
    renderCell: (data) => (
      <React.Fragment>
        <Tooltip title="Editar Insumo" placement="top">
          <IconButton
            aria-label="edit"
            color="primary"
            onClick={() => { setOpen(true); setMode("PUT"); dispatch(setDefaultData(data.row)); dispatch(setInsumoId(data.row.id)); }}
          >
            <Edit />
          </IconButton>
        </Tooltip>
        <Tooltip title="Eliminar Insumo" placement="top">
          <IconButton
            aria-label="delete"
            color="primary"
            onClick={() => { setOpenDelete(true); setMode("DELETE"); dispatch(setInsumoId(data.row.id)); }}
          >
            <Delete />
          </IconButton>
        </Tooltip>
        <Tooltip title="Generar QR" placement="top">
          <IconButton
            aria-label="qr"
            color="primary"
            onClick={() => { dispatch(setDefaultData(data.row)); handleOpenQR(); }}
          >
            <QrCode2 />
          </IconButton>
        </Tooltip>
      </React.Fragment>
    ),
  },
  {
    field: "internal",
    headerName: "Interno",
    width: 150,
    renderCell: (data) => (
      <Switch
      color="primary"
      checked={data.row.internal}
      onChange={(e)=>handleChange(e,data.row,refresh,setRefresh)}
      />
    )
  },
  {
    field: "nombre",
    headerName: "Nombre",
    width: 300,
  },
  {
    field: 'descripcion',
    headerName: "Descripción",
    width: 300,
  },
  {
    field: 'codigo',
    headerName: "Código",
    width: 100,
  },
  {
    field: 'details.presentacion',
    headerName: "Presentacion",
    width: 200,
    renderCell: (data) => (
      <>{data.row.details?.presentacion}</>
    )
  },
  {
    field: 'details.cantidad',
    headerName: "Cantidad",
    width: 200,
    renderCell: (data) => (
      <>{data.row.details?.cantidad}</>
    )
  },
]
}

